import React from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import getLocaleMessages from '../../utils/localesMessages';

const {
  preview: { paymentInfo },
} = getLocaleMessages('buttonsV3/preview');

const DonorPaymentInfoSkeleton = () => {
  return (
    <div className="payment-info-skeleton-container">
      <HeadingText size="sm" className="margin-bottom-16" theme="v1">
        {paymentInfo}
      </HeadingText>
      <div className="skeleton-linear margin-bottom-16"></div>
      <div className="skeleton-linear margin-bottom-16"></div>
      <div className="skeleton-linear skeleton-linear-last"></div>
    </div>
  );
};

export default DonorPaymentInfoSkeleton;
